import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import { useCallback } from "react";

/**
 * Login page component
 */
const Login = () => {
  const { instance } = useMsal();

  /**
   * Handle login
   */
  const handleLogin = useCallback(() => {
    instance.loginRedirect(loginRequest).catch((error) => {
      console.error("Login failed:", error);
    });
  }, [instance]);

  return (
    <div className="flex justify-center items-center h-screen bg-background">
      <div className="card" style={{ maxWidth: '400px' }}>
        <div className="flex flex-col items-center gap-lg">
          <div className="text-primary mb-md">
            <img 
              src="/Zentura bomærke - blå 2000px (Custom).png" 
              alt="Zentura Logo" 
              style={{ height: '80px', width: 'auto' }}
            />
          </div>
          <h1 className="text-primary" style={{ fontSize: 'var(--font-size-xl)', fontWeight: 'bold' }}>LMS Manager</h1>
          <p className="text-secondary text-center">
            Sign in to access the LMS Manager admin portal
          </p>
          <button 
            onClick={handleLogin}
            className="btn btn-primary"
            style={{ width: '100%', padding: 'var(--spacing-md)' }}
          >
            Sign in with Microsoft
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
